var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.789,
    height: 20,
    viewBox: "0 0 15.789 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload_File",
    "data-name": "Upload File",
    transform: "translate(-653.121 -301.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "upload_file_24dp_FILL0_wght300_GRAD0_opsz24",
    d: "M187.105-843.279h1.579v-4.668L190.632-846l1.109-1.125-3.846-3.846-3.846,3.846,1.126,1.109,1.931-1.931ZM181.9-840a1.837,1.837,0,0,1-1.35-.553A1.837,1.837,0,0,1,180-841.9V-858.1a1.837,1.837,0,0,1,.553-1.35A1.837,1.837,0,0,1,181.9-860h8.36l5.526,5.526V-841.9a1.837,1.837,0,0,1-.553,1.35,1.837,1.837,0,0,1-1.35.553Zm7.571-13.684v-4.737H181.9a.309.309,0,0,0-.223.1.309.309,0,0,0-.1.223V-841.9a.309.309,0,0,0,.1.223.309.309,0,0,0,.223.1h11.984a.309.309,0,0,0,.223-.1.309.309,0,0,0,.1-.223v-11.781Zm-7.895-4.737v0Z",
    transform: "translate(473.121 1161.999)",
    fill: "#015ca3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/Upload File.367b6f178b798849fbb508765a45398f.svg";
export { ForwardRef as ReactComponent };